













import Vue from 'vue'
import XTab from './XTab.vue'

export type TabItem<T = string> = {
  id: T
  label: string
}

type Computed = {
  selected?: string
}

type Props = {
  tabs: TabItem[]
  value?: string
}

type Methods = {
  isActive: (tab: TabItem) => boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'XTabs',
  components: { XTab },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    isActive(tab) {
      if (!this.selected) {
        return false
      }
      return tab.id === this.selected
    },
  },
  watch: {
    tabs: {
      handler() {
        if (!this.selected) {
          this.selected = this.tabs[0]?.id
        }
      },
      immediate: true,
      deep: true,
    },
  },
})
